import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import StatusesList from "./pages/StatusesList";
import StatusForm from "./pages/StatusForm";
import AircraftsList from "./pages/AircraftsList";
import AircraftForm from "./pages/AircraftForm";
import AirlinesList from "./pages/AirlinesList";
import AirlineForm from "./pages/AirlineForm";
import BasesList from "./pages/BasesList";
import BaseForm from "./pages/BaseForm";
import RolesList from "./pages/RolesList";
import RoleForm from "./pages/RoleForm";
import SeatsList from "./pages/SeatsList";
import SeatForm from "./pages/SeatForm";
import UsersList from "./pages/UsersList";
import UserForm from "./pages/UserForm";
import UserDetail from "./pages/UserDetail";
import SubAdminsList from "./pages/SubAdminsList";
import SubAdminForm from "./pages/SubAdminForm";
import QueriesList from "./pages/QueriesList";
import QueryDetail from "./pages/QueryDetail";
import EventsList from "./pages/EventsList";
import EventDetail from "./pages/EventDetail";
import ProtectedRoute from "./routes/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Statuses */}
        <Route
          path="/statuses"
          element={
            <ProtectedRoute>
              <StatusesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/statuses/new"
          element={
            <ProtectedRoute>
              <StatusForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/statuses/edit/:id"
          element={
            <ProtectedRoute>
              <StatusForm />
            </ProtectedRoute>
          }
        />

        {/* Aircrafts */}
        <Route
          path="/aircrafts"
          element={
            <ProtectedRoute>
              <AircraftsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/aircrafts/new"
          element={
            <ProtectedRoute>
              <AircraftForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/aircrafts/edit/:id"
          element={
            <ProtectedRoute>
              <AircraftForm />
            </ProtectedRoute>
          }
        />

        {/* Airlines */}
        <Route
          path="/airlines"
          element={
            <ProtectedRoute>
              <AirlinesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/airlines/new"
          element={
            <ProtectedRoute>
              <AirlineForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/airlines/edit/:id"
          element={
            <ProtectedRoute>
              <AirlineForm />
            </ProtectedRoute>
          }
        />

        {/* Bases */}
        <Route
          path="/bases"
          element={
            <ProtectedRoute>
              <BasesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bases/new"
          element={
            <ProtectedRoute>
              <BaseForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bases/edit/:id"
          element={
            <ProtectedRoute>
              <BaseForm />
            </ProtectedRoute>
          }
        />

        {/* Roles */}
        <Route
          path="/roles"
          element={
            <ProtectedRoute>
              <RolesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/roles/new"
          element={
            <ProtectedRoute>
              <RoleForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/roles/edit/:id"
          element={
            <ProtectedRoute>
              <RoleForm />
            </ProtectedRoute>
          }
        />

        {/* Seats */}
        <Route
          path="/seats"
          element={
            <ProtectedRoute>
              <SeatsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/seats/new"
          element={
            <ProtectedRoute>
              <SeatForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/seats/edit/:id"
          element={
            <ProtectedRoute>
              <SeatForm />
            </ProtectedRoute>
          }
        />

        {/* Users */}
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/new"
          element={
            <ProtectedRoute>
              <UserForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/edit/:id"
          element={
            <ProtectedRoute>
              <UserForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/detail/:id"
          element={
            <ProtectedRoute>
              <UserDetail />
            </ProtectedRoute>
          }
        />

        {/* Sub Admins */}
        <Route
          path="/sub-admins"
          element={
            <ProtectedRoute>
              <SubAdminsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sub-admins/new"
          element={
            <ProtectedRoute>
              <SubAdminForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sub-admins/edit/:id"
          element={
            <ProtectedRoute>
              <SubAdminForm />
            </ProtectedRoute>
          }
        />

        {/* Queries */}
        <Route
          path="/queries"
          element={
            <ProtectedRoute>
              <QueriesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/queries/detail/:id"
          element={
            <ProtectedRoute>
              <QueryDetail />
            </ProtectedRoute>
          }
        />

        {/* Events */}
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <EventsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/detail/:id"
          element={
            <ProtectedRoute>
              <EventDetail />
            </ProtectedRoute>
          }
        />

        {/* default */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
